export default function GetKeyFromPath(path: string) {
    return path.substring(path.lastIndexOf('/') + 1, path.lastIndexOf('.'));
}
